/**
 * @generated SignedSource<<382ae809c2712d2c3dce88bb2046c31b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectBulkCreateInput = {
  projects: ReadonlyArray<ProjectBulkCreateInputProject>;
};
export type ProjectBulkCreateInputProject = {
  client_name?: string | null | undefined;
  manager_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  name: string;
  pricing_model: string;
};
export type ProjectBulkCreateMutation$variables = {
  input: ProjectBulkCreateInput;
};
export type ProjectBulkCreateMutation$data = {
  readonly action_project_bulk_create: ReadonlyArray<{
    readonly project: {
      readonly account_id: number;
      readonly active: boolean;
      readonly actuals_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly archivable: boolean | null | undefined;
      readonly assignments_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly calc_end_date: string | null | undefined;
      readonly calc_start_date: string | null | undefined;
      readonly client: {
        readonly active: boolean;
        readonly id: number;
        readonly image_key: string | null | undefined;
        readonly name: string;
      };
      readonly client_id: number;
      readonly confirmed: boolean;
      readonly created_at: string;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly id: number;
      readonly is_template: boolean;
      readonly managers: ReadonlyArray<{
        readonly id: number;
        readonly project: {
          readonly id: number;
        };
        readonly user_id: number;
      }>;
      readonly members: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly milestones: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly name: string;
      readonly other_costs: ReadonlyArray<{
        readonly charge: number;
        readonly cost: number;
        readonly date: string | null | undefined;
        readonly id: number;
        readonly project_id: number;
      }>;
      readonly phases: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly pricing_model: string;
      readonly pricing_model_readable: string | null | undefined;
      readonly project_rates: ReadonlyArray<{
        readonly id: number;
        readonly project_id: number;
        readonly rate: number | null | undefined;
        readonly role_id: number;
      }>;
      readonly project_roles: ReadonlyArray<{
        readonly estimated_minutes: number | null | undefined;
        readonly project_id: number;
        readonly role_id: number;
      }>;
      readonly project_workstreams: ReadonlyArray<{
        readonly workstream: {
          readonly archived: boolean;
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly rate_card: {
        readonly id: number;
        readonly role_charge_out_rates: ReadonlyArray<{
          readonly charge_out_rate: number | null | undefined;
          readonly rate_card_id: number;
          readonly role_id: number;
        }>;
      };
      readonly rate_card_id: number;
      readonly references: any;
      readonly tags: any | null | undefined;
      readonly team: {
        readonly id: number;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly workstreams_computed: any | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupStats_project">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ProjectBulkCreateMutation = {
  response: ProjectBulkCreateMutation$data;
  variables: ProjectBulkCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "client_id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calc_end_date",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calc_start_date",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmed",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstreams_computed",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model_readable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate_card_id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivable",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimated_minutes",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "project_id",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v24 = [
  (v2/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "project_members",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "project_workstreams",
  "kind": "LinkedField",
  "name": "project_workstreams",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "workstreams",
      "kind": "LinkedField",
      "name": "workstream",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archived",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "project_rates",
  "kind": "LinkedField",
  "name": "project_rates",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v22/*: any*/),
    (v21/*: any*/),
    {
      "alias": "rate",
      "args": null,
      "kind": "ScalarField",
      "name": "rate_private",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "milestones",
  "kind": "LinkedField",
  "name": "milestones",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "phases",
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "order_by",
      "value": {
        "date": "asc"
      }
    }
  ],
  "concreteType": "other_costs",
  "kind": "LinkedField",
  "name": "other_costs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "charge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cost",
      "storageKey": null
    },
    {
      "alias": "date",
      "args": null,
      "kind": "ScalarField",
      "name": "date_runn",
      "storageKey": null
    }
  ],
  "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "project_managers",
  "kind": "LinkedField",
  "name": "managers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "user_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "rate_cards",
  "kind": "LinkedField",
  "name": "rate_card",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "role_charge_out_rates",
      "kind": "LinkedField",
      "name": "role_charge_out_rates",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        (v18/*: any*/),
        {
          "alias": "charge_out_rate",
          "args": null,
          "kind": "ScalarField",
          "name": "charge_out_rate_private",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "actuals_aggregate",
  "kind": "LinkedField",
  "name": "actuals_aggregate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "actuals_aggregate_fields",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": (v34/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "assignments_aggregate",
  "kind": "LinkedField",
  "name": "assignments_aggregate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "assignments_aggregate_fields",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": (v34/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_select_values",
  "kind": "LinkedField",
  "name": "custom_select_values",
  "plural": true,
  "selections": [
    {
      "alias": "optionId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_option_id",
      "storageKey": null
    },
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectBulkCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectBulkCreateOutput",
        "kind": "LinkedField",
        "name": "action_project_bulk_create",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_roles",
                "kind": "LinkedField",
                "name": "project_roles",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "clients",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectGroupStats_project"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectBulkCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectBulkCreateOutput",
        "kind": "LinkedField",
        "name": "action_project_bulk_create",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_roles",
                "kind": "LinkedField",
                "name": "project_roles",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "clients",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internal",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "accounts",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "default_full_time_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "v_summary_total",
                "kind": "LinkedField",
                "name": "summary",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "workstream_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_billable_minutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_nonbillable_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2fb3b0364d4e6e81906c956ce08baec3",
    "id": null,
    "metadata": {},
    "name": "ProjectBulkCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectBulkCreateMutation(\n  $input: ProjectBulkCreateInput!\n) {\n  action_project_bulk_create(input: $input) {\n    project {\n      id\n      name\n      account_id\n      client_id\n      active\n      calc_end_date\n      calc_start_date\n      created_at\n      references\n      team_id\n      confirmed\n      is_template\n      tags\n      workstreams_computed\n      pricing_model_readable\n      pricing_model\n      rate_card_id\n      archivable\n      project_roles {\n        estimated_minutes\n        project_id\n        role_id\n      }\n      client {\n        id\n        active\n        name\n        image_key\n      }\n      members {\n        id\n      }\n      project_workstreams {\n        workstream {\n          id\n          name\n          archived\n        }\n      }\n      project_rates {\n        id\n        role_id\n        project_id\n        rate: rate_private\n      }\n      team {\n        id\n      }\n      milestones {\n        id\n      }\n      phases {\n        id\n      }\n      other_costs(order_by: {date: asc}) {\n        id\n        project_id\n        charge\n        cost\n        date: date_runn\n      }\n      managers {\n        id\n        user_id\n        project {\n          id\n        }\n      }\n      rate_card {\n        id\n        role_charge_out_rates {\n          role_id\n          rate_card_id\n          charge_out_rate: charge_out_rate_private\n        }\n      }\n      actuals_aggregate {\n        aggregate {\n          count\n        }\n      }\n      assignments_aggregate {\n        aggregate {\n          count\n        }\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n      ...ProjectGroupStats_project\n    }\n  }\n}\n\nfragment ProjectGroupStats_project on projects {\n  id\n  is_template\n  pricing_model\n  account {\n    id\n    default_full_time_minutes\n  }\n  client {\n    id\n    internal\n  }\n  summary {\n    role_id\n    workstream_id\n    total_billable_minutes\n    total_nonbillable_minutes\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b4e4f3ac21431bfa12523cbd695016e";

export default node;
